import { render } from "./edit.vue?vue&type=template&id=5a742c66&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=5a742c66&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5a742c66"

export default script